module.exports = __webpack_public_path__ + "img/file-plus.50f33a8d.svg";